const LEVELS = [
  { // YI1
    name: `Yoshi's Island 1`,
    id: '105',
    world: 1,
    powerups: ['Mushroom', 'Yoshi'],
    dragoncoins: true,
    moon: true,
    normal: [
      {
        name: '96 Exit',
        id: 0,
        time: 263,
        link: 'ggbJON0imHI',
        desc: `You can spin the Koopa at the start of the level, but this is risky due to the cape framerule. Jumping over it only loses 1 in-game second.`,
        source: `Sten`
      },
      {
        name: '11 Exit (Orb)',
        id: 1,
        time: 249,
        link: 'i6nbwgtzm-A',
        desc: `It is faster to run back and die in the pit than it is to complete the level and walk on the overworld.`,
        source: `Sten`
      },
      {
        name: '95 Exit, No Cape',
        id: 2,
        time: 260,
        link: 'p33u8WQlnYM',
        desc: ``,
        source: `Sten`
      },
      {
        name: 'Lunar Dragon',
        id: 3,
        time: 259,
        link: 'hZznveNmmtc',
        desc: `Spinning the Koopa at the start of the level is risky, but will save time because you can get p-speed earlier.`,
        source: `Umari0`
      },
    ],
  },
  { // YI2
    name: `Yoshi's Island 2`,
    id: '106',
    world: 1,
    powerups: ['Mushroom', 'Yoshi'],
    dragoncoins: true,
    normal: [
      {
        name: 'All Categories',
        id: 0,
        time: 361,
        link: 'Hmod32SwX6w',
        desc: `Getting a 361 is only possible if you release the d-pad on the correct frame. Mario's speed oscillates (49, 48, 47, 48, 47) when you hold the d-pad. If you release when your speed is 49 subpixels per frame, you will get a 361.`,
        source: `Bramz`,
      },
      {
        name: '11 Exit (Cloud) - Easy Setup',
        id: 1,
        time: 354,
        link: 'hk8rVl6ldwY',
        desc: `Consider this strat if you are struggling with the B5 setup.`,
        source: `LostC0re`,
      },
      {
        name: '11 Exit (Cloud) - B5 Setup',
        id: 2,
        time: 356,
        link: 'ZhB4VpPE1SU',
        desc: `You need to despawn the Koopa in a pixel-perfect location. If you are struggling with this, consider the easy setup.`,
        source: `IsoFrieze`,
      },
      {
        name: '11 Exit (Orb)',
        id: 3,
        time: 358,
        link: 'xG0FNEOpYzU',
        desc: `Use this strat if you need to get Orb. This is useful in 11 Exit (Orb) and many extra categories.`,
        source: `Sten`
      },
      {
        name: 'Lunar Dragon',
        id: 4,
        time: 358,
        link: 'uxtnrmn8pUg',
        desc: ``,
        source: `Bramz`,
      }
    ],
  },
  { // YI3
    name: `Yoshi's Island 3`,
    id: '103',
    world: 1,
    powerups: ['Fire, Yoshi'],
    dragoncoins: true,
    normal: [
      {
        name: 'All Categories',
        id: 0,
        time: 259,
        link: 'gE34tasCAhE',
        desc: `Be sure to run on the brown rotating platforms for as long as possible, as they boost Mario forward. This makes the difference between 258 and 259.`,
        source: `Bramz`
      },
      {
        name: 'Lunar Dragon',
        id: 1,
        time: 256,
        link: '_eJgZYKl2iI',
        desc: `Avoiding the midway while getting p-speed is extremely tight, so when you get the midway here you may have to damage boost in Iggy's Castle.`,
        source: `Umari0`
      }
    ],
  },
  { // YI4
    name: `Yoshi's Island 4`,
    id: '102',
    world: 1,
    powerups: ['Fire'],
    dragoncoins: true,
    normal: [
      {
        name: 'All Categories',
        id: 0,
        time: 276,
        link: 'SEDKMBsngJs',
        desc: `You can perform a shell jump over the large gap in the middle of the stage, but it only saves 0.2 seconds and is quite difficult. The fastest strat without shell jumping is to crush the shell before the jump.`,
        source: `Sten`
      },
      {
        name: 'Lunar Dragon',
        id: 1,
        time: 274,
        link: 'ORg9ufySB-0',
        desc: ``,
        source: `Umari0`
      }
    ],
  },
  { // YSP
    name: `Yellow Switch Palace`,
    id: '14',
    world: 1,
    powerups: [],
    dragoncoins: false,
    normal: [
      {
        name: '96 Exit',
        id: 0,
        time: 190,
        link: 'OWr_0sRuow0',
        desc: ``,
        source: `Sten`
      },
      {
        name: '95 Exit, No Cape',
        id: 1,
        time: 189,
        link: 'thVT7W4aI2w',
        desc: ``,
        source: `Sten`
      }
    ],
  },
  { // #1C
    name: `#1 Iggy's Castle`,
    id: '101',
    world: 1,
    powerups: ['Fire'],
    dragoncoins: false,
    normal: [
      {
        name: 'All Categories',
        id: 0,
        time: 242,
        link: 'm8uShJQJmL0',
        desc: `Getting a 282 in the first room is possible, but requires superb execution.`,
        source: `Bramz`
      },
      {
        name: 'Lunar Dragon',
        id: 1,
        time: 242,
        link: '1gjveh1zgps',
        desc: `While it's possible to intentionally take damage and be small for the fence section, staying big skips the 47 frames long shrinking transition. Briefly release Y when bouncing off of the net koopa to avoid bonking on the wall. `,
        source: `Lui`
      },
    ],
  },
  { // DP1
    name: `Donut Plains 1`,
    id: '15',
    world: 2,
    powerups: ['Mushroom', 'Cape', 'Yoshi'],
    dragoncoins: true,
    normal: [
      {
        name: '96 Exit',
        id: 0,
        time: 363,
        link: 'srItRfLpFnY',
        desc: ``,
        source: `Sten`
      },
      {
        name: '95 Exit, No Cape',
        id: 1,
        time: 358,
        link: 'q38K3J8GCDo',
        desc: ``,
        source: `Sten`
      },
      {
        name: 'Small Only',
        id: 2,
        time: 360,
        link: 'qNLUQ6B9qjw',
        desc: ``,
        source: `Sten`
      },
      {
        name: 'Lunar Dragon',
        id: 3,
        time: 0,
        link: '',
        desc: ``,
        source: ``
      },
    ],
    secret: [
      {
        name: 'Cape Categories',
        id: 0,
        time: 0,
        link: '',
        desc: ``,
        source: ``
      },
      {
        name: 'No Cape Categories',
        id: 1,
        time: 360,
        link: '8BcoB2klOis',
        desc: ``,
        source: `LostC0re`
      },
      {
        name: 'Small Only',
        id: 2,
        time: 0,
        link: '',
        desc: ``,
        source: ``
      },
    ]
  },
  { // DP2
    name: `Donut Plains 2`,
    id: '9',
    world: 2,
    powerups: ['Mushroom', 'Cape'],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // DP3
    name: `Donut Plains 3`,
    id: '5',
    world: 2,
    powerups: ['Cape'],
    dragoncoins: true,
    normal: [],
  },
  { // DP4
    name: `Donut Plains 4`,
    id: '6',
    world: 2,
    powerups: ['Mushroom', 'Fire', 'Cape', 'Yoshi'],
    dragoncoins: true,
    moon: true,
    normal: [],
  },
  { // GSP
    name: `Green Switch Palace`,
    id: '8',
    world: 2,
    powerups: ['None'],
    dragoncoins: false,
    normal: [],
  },
  { // DGH
    name: `Donut Ghost House`,
    id: '4',
    world: 2,
    powerups: ['None'],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // DS1
    name: `Donut Secret 1`,
    id: 'A',
    world: 2,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // DS2
    name: `Donut Secret 2`,
    id: '10B',
    world: 2,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // DSH
    name: `Donut Secret House`,
    id: '13',
    world: 2,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // #2C
    name: `#2 Morton's Castle`,
    id: '7',
    world: 2,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // VD1
    name: `Vanilla Dome 1`,
    id: '11A',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // VD2
    name: `Vanilla Dome 2`,
    id: '118',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // VD3
    name: `Vanilla Dome 3`,
    id: '10A',
    world: 3,
    powerups: [],
    dragoncoins: true,
    moon: true,
    normal: [],
  },
  { // VD4
    name: `Vanilla Dome 4`,
    id: '119',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // RSP
    name: `Red Switch Palace`,
    id: '11B',
    world: 3,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // VGH
    name: `Vanilla Ghost House`,
    id: '107',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // VS1
    name: `Vanilla Secret 1`,
    id: '109',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // VS2
    name: `Vanilla Secret 2`,
    id: '1',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // VS3
    name: `Vanilla Secret 3`,
    id: '2',
    world: 3,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // VF
    name: `Vanilla Fortress`,
    id: 'B',
    world: 3,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // #3C
    name: `#3 Lemmy's Castle`,
    id: '11C',
    world: 3,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // BB1
    name: `Butter Bridge 1`,
    id: 'C',
    world: 4,
    powerups: ['Cape'],
    dragoncoins: true,
    normal: [],
  },
  { // BB2
    name: `Butter Bridge 2`,
    id: 'D',
    world: 4,
    powerups: ['Cape', 'Yoshi'],
    dragoncoins: true,
    normal: [],
  },
  { // CBA
    name: `Cheese Bridge Area`,
    id: 'F',
    world: 4,
    powerups: ['Cape'],
    dragoncoins: true,
    moon: true,
    normal: [],
    secret: []
  },
  { // CM
    name: `Cookie Mountain`,
    id: '10',
    world: 4,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // SL
    name: `Soda Lake`,
    id: '11',
    world: 4,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // #4C
    name: `#4 Ludwig's Castle`,
    id: 'E',
    world: 4,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // FOI1
    name: `Forest of Illusion 1`,
    id: '11E',
    world: 5,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // FOI2
    name: `Forest of Illusion 2`,
    id: '120',
    world: 5,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // FOI3
    name: `Forest of Illusion 3`,
    id: '123',
    world: 5,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // FOI4
    name: `Forest of Illusion 4`,
    id: '11F',
    world: 5,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // BSP
    name: `Blue Switch Palace`,
    id: '121',
    world: 5,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // FGH
    name: `Forest Ghost House`,
    id: '11D',
    world: 5,
    powerups: [],
    dragoncoins: true,
    moon: true,
    normal: [],
    secret: []
  },
  { // FSA
    name: `Forest Secret Area`,
    id: '122',
    world: 5,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // FF
    name: `Forest Fortress`,
    id: '1F',
    world: 5,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // #5C
    name: `#5 Roy's Castle`,
    id: '20',
    world: 5,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // CI1
    name: `Chocolate Island 1`,
    id: '22',
    world: 6,
    powerups: [],
    dragoncoins: true,
    moon: true,
    normal: [],
  },
  { // CI2
    name: `Chocolate Island 2`,
    id: '24',
    world: 6,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // CI3
    name: `Chocolate Island 3`,
    id: '23',
    world: 6,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // CI4
    name: `Chocolate Island 4`,
    id: '1D',
    world: 6,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // CI5
    name: `Chocolate Island 5`,
    id: '1C',
    world: 6,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // CGH
    name: `Choco-Ghost House`,
    id: '21',
    world: 6,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // CS
    name: `Chocolate Secret`,
    id: '117',
    world: 6,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // CF
    name: `Chocolate Fortress`,
    id: '1B',
    world: 6,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // #6C
    name: `#6 Wendy's Castle`,
    id: '1A',
    world: 6,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // SGS
    name: `Sunken Ghost Ship`,
    id: '18',
    world: 7,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // VOB1
    name: `Valley of Bowser 1`,
    id: '116',
    world: 7,
    powerups: [],
    dragoncoins: true,
    moon: true,
    normal: [],
  },
  { // VOB2
    name: `Valley of Bowser 2`,
    id: '115',
    world: 7,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // VOB3
    name: `Valley of Bowser 3`,
    id: '113',
    world: 7,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // VOB4
    name: `Valley of Bowser 4`,
    id: '10F',
    world: 7,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // VGH
    name: `Valley Ghost House`,
    id: '114',
    world: 7,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // VF
    name: `Valley Fortress`,
    id: '111',
    world: 7,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // #7C
    name: `#7 Larry's Castle`,
    id: '110',
    world: 7,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // BC
    name: `Bowser's Castle`,
    id: '10D',
    world: 7,
    powerups: [],
    dragoncoins: false,
    normal: [],
  },
  { // SW1
    name: `Star World 1`,
    id: '134',
    world: 8,
    powerups: [],
    dragoncoins: true,
    normal: [],
    secret: []
  },
  { // SW2
    name: `Star World 2`,
    id: '130',
    world: 8,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // SW3
    name: `Star World 3`,
    id: '132',
    world: 8,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // SW4
    name: `Star World 4`,
    id: '135',
    world: 8,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // SW5
    name: `Star World 5`,
    id: '136',
    world: 8,
    powerups: [],
    dragoncoins: false,
    normal: [],
    secret: []
  },
  { // Gnarly
    name: `Gnarly`,
    id: '12A',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Tubular
    name: `Tubular`,
    id: '12B',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Way Cool
    name: `Way Cool`,
    id: '12C',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Awesome
    name: `Awesome`,
    id: '12D',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Groovy
    name: `Groovy`,
    id: '128',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Mondo
    name: `Mondo`,
    id: '127',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Outrageous
    name: `Outrageous`,
    id: '126',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
  { // Funky
    name: `Funky`,
    id: '125',
    world: 9,
    powerups: [],
    dragoncoins: true,
    normal: [],
  },
];

export default LEVELS;

/*
{
  name: '',
  id: 0,
  time: 0,
  link: '',
  desc: ``,
  source: ``
},
*/